import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-070cbbda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-header d-flex justify-content-center align-items-center m-0 mb-4 mb-lg-5 p-0" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "has-message position-absolute"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caret text-center position-absolute" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down" })
], -1))

import { computed, PropType } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Tab } from '../index.vue'
import { ROOT_STORE } from '@/store/constants'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  tabs: {
    type: Array as PropType<Array<Tab>>,
  },
  defaultAlias: String,
  hasMessage: Boolean,
  keyName: Number,
  screen: String,
  loading: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const router = useRouter()
const route = useRoute()
const store = useStore()
const isMobile = computed<boolean>(() => store?.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])

const changeTab = (alias: string): void => {
  if (props.loading) return
  // router.push({ path: route.path, query: { ...route.query, tab: alias } })
  router.push(`${route.path}?tab=${alias}`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: tab.title,
        onClick: ($event: any) => (changeTab(tab.alias)),
        class: _normalizeClass([
        _unref(route).query.tab === tab.alias || (!_unref(route).query.tab && __props.defaultAlias === tab.alias) || (!_unref(route).query.tab && index === 0) ? 'active' : '',
        'fw-bold position-relative text-lg-start text-center ',
        index === 0 && __props.tabs?.length > 2 && 'first-li',
        index === 0 && __props.tabs?.length <= 2 && 'first-li-2',
        index === __props.tabs?.length - 1 && __props.tabs?.length > 2 && 'last-li',
        index === __props.tabs?.length - 1 && __props.tabs?.length <= 2 && 'last-li-2',
      ]),
        style: _normalizeStyle(__props.screen === 'points' && !_unref(isMobile) ? 'padding: 0 19.75px;' : '')
      }, [
        _createTextVNode(_toDisplayString(tab.title) + " ", 1),
        (tab.unread_count)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true),
        _hoisted_4
      ], 14, _hoisted_2))
    }), 128))
  ]))
}
}

})